<template>
  <div class="category">
    <el-button size="medium" type="info" @click="isContentShow = !isContentShow"
      >主要按钮</el-button
    >
    <div :class="isContentShow ? 'slot-block' : 'slot-block-active'">
      <slot></slot>
      <!--声明插槽-->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isContentShow: true,
    };
  },
  methods: {},
};
</script>
<style scoped>
.slot-block {
  max-height: 100px;
}
.slot-block-active {
  max-height: 100%;
}
</style>
